import styled from 'styled-components';

export const ListContainer = styled.div`
  display: flex;
  alignitems: center;
  margin: 2px 0;
`;

export const CountryName = styled.span`
  font-size: 11px;
  line-height: 1;
  padding-left: 1px;
  color: #aaa;
`;

export const CurrencyName = styled.span`
  line-height: 1;
  color: #666;
`;

export const LabelContainer = styled.span`
  display: flex;
  flex-direction: column;
  padding: 2px 0 0 5px;
`;
